import { Asset } from '../../state/types';

/**
 * Build the clipboard payload for the "Copy IDs" bulk action.
 *
 * The output is deliberately comma-space separated: that is exactly what the Asset ID
 * search splits on, so copied ids paste straight back into the search box and
 * round-trip. Selecting the same vehicle across several captures is normal, so ids are
 * deduped — duplicates would otherwise burn terms against the search's 10-term cap
 * without matching anything new. Original order is preserved so the payload lines up
 * with what the user sees in the table.
 */
export const buildAssetIdClipboardText = (assets: Asset[]): string =>
  uniqueAssetIds(assets).join(', ');

export const uniqueAssetIds = (assets: Asset[]): string[] => {
  const seen = new Set<string>();
  const ids: string[] = [];
  for (const asset of assets || []) {
    const id = (asset?.assetId || '').trim();
    if (id && !seen.has(id)) {
      seen.add(id);
      ids.push(id);
    }
  }
  return ids;
};
